module.exports = __webpack_public_path__ + "img/icon-star3.0661155d.png";